import { DeliveryLocation } from '../../api/user/user.types';
import { Async } from '../../types/data.types';
import {
  AddDeliveryOption,
  DeliveryOption,
  HCaptchaTokens,
  SetDeliveryLocations,
  SetHCaptchaToken,
  SetLoginErrorMessage,
} from './user.types';

export const addDeliveryOption = (
  dl: DeliveryLocation,
  option: DeliveryOption,
): AddDeliveryOption => ({
  type: 'ADD_DELIVERY_OPTION',
  payload: {
    dlid: dl.DeliveryLocationId,
    option,
  },
});

export const setDeliveryLocations = (
  deliveryLocations: Async<DeliveryLocation[]>,
): SetDeliveryLocations => ({
  type: 'SET_DELIVERY_LOCATIONS',
  payload: deliveryLocations,
});

export const setHCaptchaToken = (
  hCaptchaToken: HCaptchaTokens,
): SetHCaptchaToken => ({
  type: 'SET_HCAPTCHA_TOKEN',
  payload: hCaptchaToken,
});

export const setLoginErrorMessage = (
  message: string,
): SetLoginErrorMessage => ({
  type: 'SET_LOGIN_ERROR_MESSAGE',
  payload: message,
});
